<template>
<div class="invoice">
    <div class="title">
        <div class="tit_in">
            <p class="h1">我的发票</p>
            <el-button type="primary" @click="dialogTableVisible = true" plain v-show="reacodlist.length>0">开发票</el-button>
        </div>
    </div>
    <div class="datalist" v-loading="loading">
        <div v-if="!noData">
            <div class="list_list" v-for="item in reacodlist" :key="item.id" @click="getinfo(item.id)">
                <div class="top">
                    <p class="h1">{{ item.title }}</p>
                    <a href="javascript:;" class="on" v-if="item.status == 1">开票中<i class="el-icon-arrow-right"></i></a>
                    <a href="javascript:;" class="off" v-if="item.status == 2">已开票<i class="el-icon-arrow-right"></i></a>
                </div>
                <div class="bot">
                    <p>
                        开票金额：<b>{{ item.money }}元</b>
                    </p>
                    <p>开票时间：{{ item.createTime }}</p>
                    <p>电子邮箱：{{ item.email }}</p>
                </div>
            </div>
        </div>

        <div class="nodata" v-else>
            <img src="@/assets/img/zwfp.jpg" alt="" />
            <p>暂无发票记录</p>
            <button @click="dialogTableVisible = true">开发票</button>
        </div>
    </div>
    <div class="next-load" v-if="!noData && reacodlist.length>5">
        <span v-show="loading"><i class="el-icon-loading"></i>加载中...</span>
        <span v-show="isLast">已加载全部</span>
    </div>
    <el-dialog @open="getapplyList" :visible.sync="dialogTableVisible" class="eltable" :show-close="false" :header="false" width="60%">
        <div class="title">
            <div class="tit_in">
                <p class="h1">可选择订单</p>
                <el-button @click="dialogTableVisible = false" plain>取消</el-button>
            </div>
        </div>
        <el-table :data="gridData" border style="width: 100%" stripe @selection-change="handleSelectionChange">>
            <el-table-column property="check" label="" type="selection" fixed></el-table-column>
            <el-table-column property="orderName" label="套餐名称" align="center"></el-table-column>
            <el-table-column property="createTime" label="下单时间" align="center" min-width="180"></el-table-column>
            <el-table-column property="year" label="套餐类型(年)" align="center" min-width="120"></el-table-column>
            <el-table-column property="amount" label="金额(元)" align="center" min-width="80"></el-table-column>
        </el-table>
        <div class="next">
            <p>
                已选择<i>{{ nextdata.num }}</i>个订单
            </p>
            <p>
                共计<b> {{ nextdata.money }} </b>元
            </p>
            <button @click="toaddinvoice">下一步</button>
        </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" width="50%" class="eltable invoiceinfo">
        <div class="title">
            <div class="tit_in">
                <p class="h1">发票详情</p>
                <el-button @click="dialogVisible = false" plain>关闭</el-button>
            </div>
        </div>
        <div class="article">
            <p class="h1">发票状态：</p>
            <div>
                <p class="h2">开票状态：</p>
                <p style="color: #3779ff;" class="h3" v-if="invoiceinfo.status == 1">开票中</p>
                <p class="h3" v-if="invoiceinfo.status == 2">已开票</p>
            </div>
            <div>
                <p class="h2" v-if="invoiceinfo.status == 2" style="white-space:nowrap;">发票连接：</p>
                <p class="h3  link" @click="preview" v-if="invoiceinfo.status == 2" style="cursor: pointer;color: #3779ff;text-decoration: underline;">电子普通发票预览</p>
            </div>
        </div>
        <div class="article">
            <p class="h1">发票信息</p>
            <div>
                <p class="h2">发票金额：</p>
                <p class="h3">{{ invoiceinfo.money }}</p>
            </div>
            <div v-if="invoiceinfo.type == 2">
                <p class="h2">公司税号：</p>
                <p class="h3">{{ invoiceinfo.taxNumber }}</p>
            </div>
            <div>
                <p class="h2">发票抬头：</p>
                <p class="h3">{{ invoiceinfo.title }}</p>
            </div>
            <div v-if="invoiceinfo.type == 2">
                <p class="h2">开户银行：</p>
                <p class="h3">{{ invoiceinfo.bank }}</p>
            </div>
            <div v-if="invoiceinfo.type == 2">
                <p class="h2">银行账户：</p>
                <p class="h3">{{ invoiceinfo.account }}</p>
            </div>
            <div v-if="invoiceinfo.type == 1">
                <p class="h2">身份证号：</p>
                <p class="h3">{{ invoiceinfo.idCard }}</p>
            </div>
            <div v-if="invoiceinfo.type == 2">
                <p class="h2">企业地址：</p>
                <p class="h3">{{ invoiceinfo.address }}</p>
            </div>
            <div v-if="invoiceinfo.type == 2">
                <p class="h2">联系人：</p>
                <p class="h3">{{ invoiceinfo.linkman }}</p>
            </div>
            <div>
                <p class="h2">联系电话：</p>
                <p class="h3">{{ invoiceinfo.phone }}</p>
            </div>
            <div>
                <p class="h2">电子邮箱：</p>
                <p class="h3">{{ invoiceinfo.email }}</p>
            </div>
        </div>
        <div class="articletable">
            <p class="h1">订单信息</p>
            <el-table :data="applyOrderList" border style="width: 100%" stripe height="250">
                <el-table-column fixed prop="project" label="支付项目" min-width="150" align="center">
                </el-table-column>
                <el-table-column prop="year" label="套餐类型(年)" min-width="120" align="center">
                </el-table-column>
                <el-table-column prop="createTime" label="支付时间" min-width="200" align="center">
                </el-table-column>
                <el-table-column prop="amount" label="支付金额(元)" min-width="120" align="center">
                </el-table-column>
            </el-table>
        </div>
    </el-dialog>
</div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            dialogTableVisible: false,
            dialogVisible: false,
            data: "",
            gridData: [],
            reacodlist: [],
            orderIdList: "",
            nextdata: {
                num: 0,
                money: 0
            },
            datalist: false,
            invoiceinfo: "",
            applyOrderList: [],
            loading: true,
            noData: false,
            page: {
                limit: 10,
                page: 1
            },
            isLast: false,
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.getList();
        addEventListener("scroll", this.handleScroll, true); //监听函数
    },
    methods: {
        handleScroll() {
            let scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop; //变量scrollTop是滚动条滚动时，距离顶部的距离
            let windowHeight =
                document.documentElement.clientHeight || document.body.clientHeight; //变量windowHeight是可视区的高度
            let scrollHeight =
                document.documentElement.scrollHeight || document.body.scrollHeight; //变量scrollHeight是滚动条的总高度
            var sum = Math.abs(Math.floor(scrollTop + windowHeight) - scrollHeight);
            if (!this.isLast && sum <= 1 && !this.loading) {
                this.loading = true;
                this.page.page++;
                this.getList();
            }
        },
        preview() {
            window.open(this.invoiceinfo.link, '_blank')
        },
        getList() {
            this.$http
                .get("/app/invoicerecord/reacodlist", {
                    params: this.page
                })
                .then((res) => {
                    this.loading = false;
                    if (res.data.code == 0) {
                        this.reacodlist.push(...res.data.data.list);
                        if (this.reacodlist.length == 0) {
                            this.noData = true;
                        }
                        if (this.page.page * this.page.limit >= res.data.data.totalCount) {
                            this.isLast = true;
                        }
                    }
                });
        },
        getapplyList() {
            //获取订单列表
            this.$http.get("/app/invoicerecord/applyList").then((res) => {
                // console.log(res);
                if (res.data.code == 0) {
                    this.gridData = res.data.data;
                    this.gridData.forEach(ele => {
                        ele.year = ele.year + '年套餐';
                    });
                }
            });
        },
        getinfo(id) {
            this.$http.get("/app/invoicerecord/info/" + id).then((res) => {
                // console.log(res);
                if (res.data.code == 0) {
                    this.invoiceinfo = res.data.data;
                    this.applyOrderList = this.invoiceinfo.applyOrderList;
                    this.applyOrderList.forEach(ele => {
                        ele.year = ele.year + '年套餐';
                        if (ele.vipTaocanType == 1) {
                            ele.project = "个人会员"
                        } else {
                            if (ele.payUse == 1) {
                                ele.project = `企业${ele.num}人会员`
                            } else if (ele.payUse == 2) {
                                ele.project = `企业${ele.num}人续费`
                            } else if (ele.payUse == 3) {
                                ele.project = `企业套餐升级${ele.num}人`
                            }
                        }
                    });
                    this.dialogVisible = true;
                    // console.log(this.applyOrderList);
                }
            });
        },
        handleSelectionChange(val) {
            // console.log(val);
            let array = [];
            this.nextdata.num = val.length;
            this.nextdata.money = 0;
            for (var i = 0; i < val.length; i++) {
                array.push(val[i].orderId);
                this.nextdata.money += val[i].amount;
            }
            this.orderIdList = array.join(",");
        },
        toaddinvoice() {
            if (this.nextdata.num <= 0) {
                this.$message.error("请至少选择一条数据");
            } else {
                // console.log(this.orderIdList);
                this.$router.push({
                    name: "addinvoice",
                    params: {
                        orderidlist: this.orderIdList,
                    },
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.next-load {
    height: 40px;
    line-height: 40px;
    position: relative;
    font-size: 14px;
    text-align: center;
    color: #999;

    i {
        font-size: 22px;
        margin-right: 10px;
    }

    &::after {
        position: absolute;
        content: "";
        top: 19px;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #ddd;
        z-index: 2;
    }

    span {
        padding: 0 30px;
        display: inline-block;
        background-color: #f5f5f5;
        position: relative;
        z-index: 10;
    }
}

.title {
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #eeeeee;

    .tit_in {
        width: 95%;
        height: 60px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .h1 {
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 1px;
            color: #333333;
            height: 20px;
            line-height: 20px;
            border-left: 3px solid #3779ff;
            padding-left: 15px;
        }
    }
}

.nodata {
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    p {
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 1px;
        color: #333333;
        margin: 20px 0;
    }

    button {
        width: 200px;
        height: 44px;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #3779ff;
        color: #3779ff;
        font-size: 16px;

        &:hover {
            color: #fff;
            border: solid 1px #fff;
            background-color: #3779ff;
            cursor: pointer;
        }
    }
}

.datalist {
    background: #fff;
    padding: 20px;
    margin: 0 auto;

    .list_list {
        width: 100%;
        margin-top: 20px;
        border-radius: 4px;
        border: solid 1px #eeeeee;
        cursor: pointer;

        >div {
            width: 100%;
            padding: 0 20px;
            height: 60px;
            box-sizing: border-box;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .top {
            background-color: #f5f5f5;

            .h1 {
                font-size: 16px;
                font-weight: bold;
                color: #333333;
            }

            a {
                font-size: 14px;
                color: #3779ff;

                i {
                    color: #3779ff;
                    margin-left: 5px;
                }
            }

            .off {
                color: #666;
            }
        }

        .bot {
            justify-content: flex-start;

            p {
                font-size: 14px;
                color: #333333;
                margin-right: 60px;

                b {
                    font-weight: normal;
                    color: #3779ff;
                }
            }
        }
    }
}

.eltable {
    .title {
        .tit_in {
            width: 100%;
        }
    }
}

.next {
    width: 100%;
    height: 50px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    padding-bottom: 20px;

    p {
        height: 50px;
        margin-right: 40px;
        line-height: 70px;
        font-size: 14px;

        i {
            color: #3779ff;
        }

        b {
            font-size: 26px;
            color: #3779ff;
            font-weight: normal;
            line-height: 20px;
        }
    }

    button {
        width: 160px;
        height: 44px;
        background-color: #3779ff;
        border-radius: 4px;
        font-size: 14px;
        font-weight: bold;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
}

.invoiceinfo {
    .article {
        width: 95%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 30px;

        .h1 {
            width: 100%;
            font-size: 16px;
            letter-spacing: 1px;
            color: #333333;
            margin-bottom: 15px;
            font-weight: 600;
        }

        >div {
            width: 50%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 15px;

            p {
                font-size: 12px;
                color: #666666;
            }

            .h2 {
                width: 60px;
                text-align: right;
            }

            .h3 {
                color: #333333;
            }
        }
    }

    .articletable {
        width: 95%;
        margin: 0 auto;
        margin-top: 30px;
        color: #333 !important;

        .h1 {
            width: 100%;
            font-size: 16px;
            letter-spacing: 1px;
            color: #333333;
            margin-bottom: 15px;
            font-weight: 600;
        }

        .tabhead {
            background: #eee;
        }
    }
}

/deep/.el-table thead {
    color: #666;
}

/deep/.el-table--border th {
    border-right: #eee 1px solid;
    background: #f5f5f5;
    font-weight: 600;
    color: #333;
}

/deep/.el-table td,
/deep/.el-table th.is-leaf {
    border-bottom: #eee 1px solid;
    font-size: 12px;
    font-weight: 600;
    color: #333;
}

/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #f5f5f5;
}
</style>
